import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as moment from 'moment';
import * as i0 from "@angular/core";
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
export class ExcelService {
    constructor() {
    }
    exportAsExcelFile(json, excelFileName) {
        const worksheet = XLSX.utils.json_to_sheet(json);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }
    saveAsExcelFile(buffer, fileName) {
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        let dateMoment = moment();
        const fecha = dateMoment.format("DD-MM-YYYY");
        FileSaver.saveAs(data, fileName + '_' + fecha + EXCEL_EXTENSION);
    }
}
ExcelService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExcelService_Factory() { return new ExcelService(); }, token: ExcelService, providedIn: "root" });
